
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/step-guide/funeral-with-oneday-binso",
      function () {
        return require("private-next-pages/step-guide/funeral-with-oneday-binso.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/step-guide/funeral-with-oneday-binso"])
      });
    }
  